import * as React from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';
import { DynamicPhoneLinkWrapper } from '../../../components/DynamicPhoneLinkWrapper';
import { PhoneLinkQRCode } from '../../../components/PhoneLinkQRCode';
import { IBuilder } from '../../../types/newbuilding/builder';
import { ISeller } from '../../../types/newbuilding/seller';
import { formatNumber, getPhoneLink, phoneToString } from '../../../utils/phoneToString';
import { NewbuildingDynamicPhone } from '../../NewbuildingDynamicPhone';

interface IPhoneContainerProps {
  contact: IBuilder | ISeller;
  placeType: string;
}

export const PhoneContainer = ({ contact, placeType }: IPhoneContainerProps) => {
  const notFormattedPhone = React.useMemo(() => phoneToString(contact.phone), [contact]);
  const formattedPhone = React.useMemo(() => formatNumber(contact.phone), [contact]);
  const linkPhone = React.useMemo(() => getPhoneLink(contact.phone), [contact]);

  if (contact.dynamicCalltracking?.siteBlockId) {
    return (
      <UIText2 fontWeight="bold">
        <NewbuildingDynamicPhone
          placeType={placeType}
          siteBlockId={contact.dynamicCalltracking.siteBlockId}
          notFormattedPhone={notFormattedPhone}
          phoneNumber={formattedPhone}
        />
      </UIText2>
    );
  }

  return (
    <DynamicPhoneLinkWrapper>
      <a href={linkPhone} data-testid="PhoneLink">
        <UIHeading3>{formattedPhone}</UIHeading3>
      </a>
      <PhoneLinkQRCode phoneLink={linkPhone} formattedPhone={formattedPhone} />
    </DynamicPhoneLinkWrapper>
  );
};
